import { Component, EventEmitter, Input, Output } from "@angular/core";
import ImageEditor from "tui-image-editor";
import { Globals } from "../../app.globals";
import { DmsService } from "../dms/dms.service";

@Component({
    standalone: false,
    selector: "image-markup",
    templateUrl: "./image-markup.html",
    providers: [DmsService],
})
export class ImageMarkup {
    @Input("src") source: string = "#";
    @Input("fileName") fileName: string;
    @Input("viewURL") viewURL: string;

    @Output() onChange: EventEmitter<string> = new EventEmitter<string>();

    showModal: boolean = false;

    readonly id: string = Math.random().toString(36).substring(2);

    private photoEditor: ImageEditor;
    private readonly dmsService: DmsService;
    private imageUrl: string;
    globals: Globals;

    constructor(dmsService: DmsService, globals: Globals) {
        this.dmsService = dmsService;
        this.globals = globals;
    }

    editImage = (event: MouseEvent) => {
        this.showModal = true;

        if (this.globals.mobileAndTabletCheck()) return;

        this.imageUrl = this.viewURL;

        if (this.imageUrl.indexOf("file=") > -1)
            this.imageUrl = this.imageUrl.substring(
                this.imageUrl.indexOf("file=") + 5
            );

        const _editImage = (
            parameters: { id: string; source: string; fileName: string }[]
        ) => {
            this.globals.showSpinner();

            var source = parameters[0].source;

            this.photoEditor = new ImageEditor(
                "#modal-body-" + parameters[0].id,
                {
                    usageStatistics: false,
                    includeUI: {
                        loadImage: {
                            path: source,
                            name: parameters[0].fileName,
                        },
                        uiSize: {
                            height: "calc(100vh - 70px - 50px)",
                            width: "100%",
                        },
                        menu: ["crop", "draw", "flip", "rotate", "text"],
                        menuBarPosition: "bottom",
                        usageStatistics: false,
                    },
                }
            );

            this.globals.hideSpinner();
        };

        setTimeout(_editImage.bind(this), 100, [
            {
                id: this.id,
                source: this.appendTimestamp(this.imageUrl),
                fileName: this.fileName,
            },
        ]);
    };

    view = async (event: MouseEvent) => {
        try {
            let imageUrl = this.viewURL;

            window.open(imageUrl, "_blank");

            this.destroy();
        } catch (error) {
            console.log(error);
        } finally {
            this.globals.hideSpinner();
        }
    };

    update = async (event: MouseEvent) => {
        try {
            let imageUrl = this.imageUrl;

            let base64 = this.photoEditor.toDataURL();

            let contentType = this.getContentType(imageUrl);

            let blob = this.base64ToBlob(base64, contentType);

            this.globals.showSpinner();

            let response = await this.dmsService.updateFile(
                imageUrl,
                blob,
                this.fileName
            );

            this.imageUrl = this.source =
                response.url + "?v=" + new Date().getTime();

            this.onChange?.emit(response.url);

            this.destroy();
        } catch (error) {
            console.log(error);
        } finally {
            this.globals.hideSpinner();
        }
    };

    private getContentType = (url: string): string => {
        let extensionIndex = url.lastIndexOf(".");
        let extension = url;

        if (extensionIndex > -1) extension = url.substr(extensionIndex + 1);

        extension = extension.toLowerCase();

        switch (extension) {
            case "ico":
                return "image/x-icon";
            case "jpg":
                return "image/jpeg";
            case "svg":
                return "image/svg+xml";
            case "tif":
                return "image/tiff";
            default:
                return "image/" + extension;
        }
    };

    private base64ToBlob = (
        base64: string,
        contentType = "",
        sliceSize = 512
    ) => {
        if (base64.indexOf(",") > -1)
            base64 = base64.substr(base64.indexOf(",") + 1);

        const byteCharacters = atob(base64);
        const byteArrays = [];

        for (
            let offset = 0;
            offset < byteCharacters.length;
            offset += sliceSize
        ) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: contentType });
    };

    private appendTimestamp(fileName: string): string {
        if (fileName.indexOf("?") > -1)
            return fileName + "&t=" + new Date().getTime();
        else return fileName + "?t=" + new Date().getTime();
    }

    destroy() {
        this.showModal = false;
        if (this.photoEditor) this.photoEditor.destroy();
    }
}
